import {QuizQuestion} from "./QuizQuestion";
import {map} from "rxjs";
import {ActivitySaveResult} from "../activity/ActivitySaveResult";

export class QuizViewModel extends ActivitySaveResult {
  id!: string;
  questions!: Array<QuizQuestion>;
  get question(): QuizQuestion {
    return this.questions[0];
  }
  constructor(data: any) {
    super(data.resultData);
    if (data !== null && data.resultData !== null && data.resultData.activityUid !== null) {
      this.id = data.resultData.activityUid;
      this.questions = data.resultData.questions.map((q:any) => new QuizQuestion(q));
    }
  }
}


